import '@jinkosoft/scss-utility/src/image-utility.scss'

import 'vue-multiselect/dist/vue-multiselect.css'

import "@jinkosoft/overlay/src/styles/tailwind.scss"

import "@jinkosoft/image-association/styles/default.scss"

import '../styles/admin.scss'

import 'v-calendar/style.css';

import '@imengyu/vue3-context-menu/lib/vue3-context-menu.css'

import "@vue-flow/core/dist/style.css";
import "@vue-flow/core/dist/theme-default.css";
import "@vue-flow/controls/dist/style.css";

import ContextMenu from '@imengyu/vue3-context-menu'
import VCalendar from 'v-calendar';

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from '../App.vue'

import { router } from '../router/admin.js'
import draggable from "vuedraggable"
import i18n, { loadLocaleMessages } from '../i18n/admin.js'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { faApple, faGoogle, faMicrosoft } from '@fortawesome/free-brands-svg-icons'

// Componenti Jinkosoft
import VueLocalization from '@jinkosoft/localization'
import VueAjaxMultiselect from '@jinkosoft/ajax-multiselect'
import VueAjaxMultiSelectList from '@jinkosoft/multi-select-list'
import VueTextField from '@jinkosoft/text'
import VueFileField from '@jinkosoft/file-field'
import VueMultiselect from 'vue-multiselect'
import { vClickOutside } from '@jinkosoft/custom-directives'
import VueCookies from 'vue-cookies'

import {useDateTime} from "@jinkosoft/datetime";

import {gql} from "graphql-tag";

import { DefaultApolloClient } from '@vue/apollo-composable'
import { useApolloClient } from '@/apollo/useApolloClient.js'
import { useApolloOverlayLoadingLink } from "@/apollo/useApolloOverlayLoadingLink.js"
import { useApolloErrorLink } from "@/apollo/useApolloErrorLink.js";
import { useApolloAuth } from "@/apollo/useApolloAuth.js";

import settingsBlock from '@/graphql/blocks/settings'

import { setGlobalQueryBlocks } from '@/apollo/queryBlocksRegistry'
import { useLocaleStore } from '@/composables/useLocaleStore'
import { applyPublicLocale, isPublicRoute, resolvePublicLocale } from '@/composables/usePublicLocale'

const t = (...args) => i18n.global.t(...args)

import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import {useFallback} from "@/composables/useFallback.js";

window.Pusher = Pusher

const reverbScheme = import.meta.env.VITE_REVERB_SCHEME || 'http'
const reverbPort = Number(import.meta.env.VITE_REVERB_PORT || (reverbScheme === 'https' ? 443 : 80))
const reverbHost = import.meta.env.VITE_REVERB_HOST === 'localhost'
    ? '127.0.0.1'
    : import.meta.env.VITE_REVERB_HOST

window.Echo = new Echo({
    broadcaster: 'reverb',
    key: import.meta.env.VITE_REVERB_KEY, // deve corrispondere a REVERB_APP_KEY
    wsHost: reverbHost,
    wsPort: reverbPort,
    wssPort: reverbPort,
    forceTLS: reverbScheme === 'https',
    disableStats: true,
    enabledTransports: reverbScheme === 'https' ? ['wss'] : ['ws'],
    authEndpoint: `${import.meta.env.VITE_BASE_URL}/broadcasting/auth`,
})

setGlobalQueryBlocks([
    {
        block: settingsBlock
    }
])

const ADMIN_PROFILE_QUERY = gql`
    query {
        adminProfile {
            id
            name
            email
            email_verified
            email_verified_at
            setup_completed
            setup_completed_at
            newsletter_opt_in_requested_at
            locale
            tenants {
                id
                endpoint
                type
                subscription_plan
                subscription_status
                subscription_offer
                subscription {
                    id
                    offer_key
                    product_key
                    plan
                    status
                    provider
                    provider_customer_id
                    provider_subscription_id
                    starts_at
                    trial_ends_at
                    current_period_ends_at
                    ends_at
                    limits
                    metadata
                }
                subscriptions {
                    id
                    offer_key
                    product_key
                    plan
                    status
                    provider
                    provider_customer_id
                    provider_subscription_id
                    starts_at
                    trial_ends_at
                    current_period_ends_at
                    ends_at
                    limits
                    metadata
                }
                active_modules
                modules {
                    id
                    module_key
                    status
                    plan
                    starts_at
                    ends_at
                }
                trial_started_at
                trial_ends_at
                trial_expired
                trial_product
                requires_upgrade
                upgrade_url
            }
        }
    }
`

// Configurazione FontAwesome
library.add(fas, faApple, faGoogle, faMicrosoft)

// Inizializza l'app Vue con App.vue
const pinia                     = createPinia()
const app                = createApp(App)

const {
    createApolloClient
} = useApolloClient()

const {
    getApolloErrorLink
} = useApolloErrorLink()

const {
    getDefaultOverlayLoadingLink
} = useApolloOverlayLoadingLink()

const {
    authContext
} = useApolloAuth(router)

const apolloClient = createApolloClient({
    graphqlBaseUrl  : import.meta.env.VITE_BASE_URL,
    errorLink       : getApolloErrorLink(router),
    loadingLink     : getDefaultOverlayLoadingLink(pinia),
    authContext     : authContext,
    router          : router,
    uri             : ({ graphqlBaseUrl, router }) => {

        const path                  = window.location.pathname
        const tenantIdMatch= path.match(/^\/([^\/]+)/)
        const tenantId          = tenantIdMatch ? tenantIdMatch[1] : null

        const publicSegments = ['login', 'auth', 'public', 'apps', 'workspaces', 'setup']

        // Se è una route senza tenant, usa fallback senza tenant
        if (!tenantId || publicSegments.includes(tenantId)) {
            return `${graphqlBaseUrl}/graphql`
        }

        // Costruisci URL con tenant: {base_url}/{tenantId}/graphql
        return `${graphqlBaseUrl}/${tenantId}/graphql`
    }
})

app.provide(DefaultApolloClient, apolloClient)

app.use(pinia)
app.use(router)

app.use(VueCookies)

app.use(VCalendar, {})
app.use(ContextMenu)

app.use(VueLocalization)
app.component('VueMultiselect', VueMultiselect)
app.use(VueTextField)
app.use(VueFileField)
app.use(VueAjaxMultiselect)
app.use(VueAjaxMultiSelectList)

app.component('draggable', draggable)

app.component('fa-icon', FontAwesomeIcon)

app.component('VueDatePicker', VueDatePicker)

app.directive('click-outside', vClickOutside)

// Inizializza l'app
router.isReady().then(async () => {

    const { fallback }  = useFallback()
    const settingsStore = useSettingsStore()
    const adminAuthStore = useAdminAuthStore()
    const publicRoute = isPublicRoute(router.currentRoute.value)
    let adminProfile = null

    if (publicRoute) {
        await applyPublicLocale(resolvePublicLocale())
    } else {
        await settingsStore.loadSettings()
        adminProfile = await loadInitialAdminProfile(apolloClient)
    }

    if (adminProfile?.id) {
        adminAuthStore.setAdmin(adminProfile)
    }

    app.provide('$settings', settingsStore.settings)
    app.config.globalProperties.$settings = settingsStore.settings

    app.provide('$fallback', fallback)
    app.config.globalProperties.$fallback = fallback

    if (!publicRoute) {
        await loadLocaleMessages(adminProfile?.locale || 'en');
    }

    const { formatDateTime } = useDateTime({
        dateTimeFormat: t('common.datetime_format'),
        never: t('common.datetime_never')
    })

    app.provide('$formatDateTime', formatDateTime)
    app.config.globalProperties.$formatDateTime = formatDateTime

    app.use(i18n).mount('#jinkosoft-vue-app')
})

async function loadInitialAdminProfile(apolloClient) {
    if (!VueCookies.get('admin_token')) {
        return null
    }

    try {
        const { data } = await apolloClient.query({
            query: ADMIN_PROFILE_QUERY,
            fetchPolicy: 'network-only',
        })

        return data?.adminProfile ?? null
    } catch (error) {
        console.error(error)

        return null
    }
}
